import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import { Button, DialogContent, IconButton } from "@mui/material";
import closeButton from "../../Assets/popup-close.svg";
//import WorkflowTemplateServiceController from "../../Controllers/WorkflowTemplateController/WorkflowTemplateservice";

const ConfirmPopup = ({ openConfirmationPopup, onClose, handleDeleteTemplate, handlePublishTemplate, handleCloneTemplate, confirmRemoveTask, isLoading, popupData }) => {

  const handleClose = () => onClose();
  var Spinner = require('react-spinkit');

  const handleDeleteRow = async (uniqueId) => {
    handleDeleteTemplate(uniqueId);
  };
  const handlePublishClick = async (uniqueId, mode) => {
    handlePublishTemplate(uniqueId, mode);
  };

  const handleCloneClick = async (uniqueId) => {
    handleCloneTemplate(uniqueId);
  };

  const removeTask = () => {
    confirmRemoveTask(true, popupData.dataId);
  }

  const handleClickEvent = (type, id) => {
    switch (type) {
      case "delete":
        handleDeleteRow(id);
        break;
      case "publish":
        handlePublishClick(id, 'publish');
        break;
      case "unpublish":
        handlePublishClick(id, 'published');
        break;
      case "clone":
        handleCloneClick(id);
        break;
      case "remove":        
        removeTask();
        break;
      default:
        console.log(
          "no function defined for click event inside confirmation popup"
        );
        break;
    }
  };

  return (
    <Dialog
      open={openConfirmationPopup}
      onClose={handleClose}
      slotProps={{
        backdrop: {
          style: { backgroundColor: 'rgba(0, 0, 0, 0.1)' }, // Adjust the opacity here
        },
      }}
      maxWidth="xs"
      fullWidth
    >
      <DialogTitle>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            margin: "0px 5px",
          }}
        >
          <p>Confirmation</p>
          <IconButton onClick={handleClose}>
            <img src={closeButton} alt="close-button" />
          </IconButton>
        </div>
      </DialogTitle>
      <DialogContent>
        {
          popupData.popupType === 'remove' ?
            <p>Are you sure you want to {popupData.popupType} this task and its related fields pertaining to this {popupData.template}....? <br />Confirm your changes by clicking <strong>SAVE </strong> button.</p>
            :
            <p>Are you sure you want to {popupData.popupType === "publish"
              ? "UnPublish"
              : popupData.popupType === "unpublish"
                ? "Publish"
                : popupData.popupType} the {popupData.template} template : <strong>"{popupData.name === "Publish"
                  ? "UnPublish"
                  : popupData.name === "Unpublish"
                    ? "Publish"
                    : popupData.name}" </strong>... ?</p>
        }

        <div className="saveTemplate-button">
          <Button
            variant="contained"
            style={{ backgroundColor: popupData.popupType === "publish" ? "#02ACF6" : '#ff0000', textTransform: 'capitalize', height: '37px', width: 'auto' }}
            onClick={() => handleClickEvent(popupData.popupType, popupData.dataId)}
            className="dialog-save-button"
          >
            {isLoading ? <Spinner name="three-bounce" color="#fff" /> : popupData.popupType === "publish"
              ? "UnPublish"
              : popupData.popupType === "unpublish"
                ? "Publish"
                : popupData.popupType}
          </Button>
          <Button
            variant="contained"
            style={{ backgroundColor: "#757ea5", textTransform: "none" }}
            onClick={handleClose}
            className="dialog-save-button"
          >
            Cancel
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ConfirmPopup;
